import React, {createContext, useContext, useState} from 'react';

const StateContext = createContext();

const initialState = {
    userProfile: false,
}

export const ContextProvider = ({children}) => {

    const [activeMenu, setActiveMenu] = useState (true);
    const [isClicked, setIsClicked] = useState (initialState);
    const [screenSize, setScreenSize] = useState(undefined);
    const [aboutToolsSlide, setAboutToolsSlide] = useState(0); // Global slide state
    const [isLogged, setIsLogged] = useState(!!localStorage.getItem('jwt'));
    const [profileVisible, setProfileVisible] = useState(false);
    const [holderChart, setHolderChart] = useState (null);
    

    const handleClick = (clicked) => {
        setIsClicked({
            ...initialState, [clicked] : true
        });
    }

    

    return (
        <StateContext.Provider value = {{
            profileVisible,
            setProfileVisible,
            isLogged,
            setIsLogged,
            activeMenu,
            setActiveMenu,
            isClicked,
            setIsClicked,
            handleClick,
            screenSize,
            setScreenSize,
            aboutToolsSlide, // Provide the global slide state
            setAboutToolsSlide, // Provide function to update the slide state
            holderChart,
            setHolderChart,
            }}
        >

        {children}
        </StateContext.Provider>
    )
}

export const useStateContext = () => useContext(StateContext);